export default __webpack_public_path__ + "static/media/sidebar_logout.1628a72a.svg";